/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Structure } from './structure';


/**
 * building
 */
export interface StructureGroup { 
    /**
     * primary Key
     */
    id: number;
    /**
     * ID of the staging datatable to identify the building
     */
    originalId: string;
    /**
     * ID of the customers datatable to identify the building
     */
    externalId: string;
    /**
     * Name of the building
     */
    structureGroupName: string;
    /**
     * List of external resources with meta-infos
     */
    externalUrls?: string;
    structures?: Array<Structure>;
    /**
     * Number of structures
     */
    structureCount: number;
    /**
     * tenant key for access management
     */
    tenantId?: number;
}

